import { api } from './ApiService';

export const getNotificationList = () => {
  return api.get(`/notifications`);
};

export const getUserNotificationList = (id) => {
  return api.get(`/notifications/user/${id}`);
};

export const getCustomerNotificationList = (id) => {
  return api.get(`/notifications/customer/${id}`);
};

export const changeUserNotification = (id, data) => {
  return api.put(`/notifications/user/${id}`, data);
};

export const changeCustomerNotification = (id, data) => {
  return api.put(`/notifications/customer/${id}`, data);
};
